export {
  /**
   * @deprecated Use ../lib/sj-orm/
   */
  getCollectionNameByDtoId as isDtoId,
} from '../lib/sj-orm/';
